var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UpfrontContributionBase',[_c('ContributionsEdit',{attrs:{"isOnboarding":true,"id":_vm.id,"value":_vm.value,"routeToConfirmation":_vm.routeToConfirmation},on:{"skip":_vm.onSkip}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }